<template>
    <el-dialog :visible.sync="isActive" width="800">
        <div>
            <div
                style="flex-direction: column"
                class="flex flex-col justify-content-center align-items-center"
            >
                <svg
                    width="62"
                    height="62"
                    viewBox="0 0 62 62"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M26.4467 44.6477L48.0165 23.0779L44.6355 19.6969L26.4467 37.8856L17.303 28.7419L13.922 32.1229L26.4467 44.6477ZM31.0055 61.4791C26.7899 61.4791 22.8275 60.6791 19.1183 59.0793C15.4089 57.4794 12.1824 55.3081 9.43856 52.5655C6.69469 49.8229 4.52246 46.5977 2.92187 42.8901C1.32129 39.1825 0.520996 35.2209 0.520996 31.0054C0.520996 26.7898 1.32094 22.8274 2.92083 19.1182C4.52072 15.4089 6.69196 12.1823 9.43455 9.43847C12.1772 6.6946 15.4023 4.52237 19.11 2.92178C22.8176 1.3212 26.7792 0.520905 30.9947 0.520905C35.2102 0.520905 39.1727 1.32085 42.8819 2.92074C46.5912 4.52063 49.8178 6.69187 52.5616 9.43446C55.3055 12.1771 57.4777 15.4023 59.0783 19.1099C60.6789 22.8175 61.4792 26.7791 61.4792 30.9946C61.4792 35.2102 60.6792 39.1726 59.0793 42.8818C57.4795 46.5911 55.3082 49.8177 52.5656 52.5615C49.823 55.3054 46.5978 57.4776 42.8902 59.0782C39.1826 60.6788 35.221 61.4791 31.0055 61.4791Z"
                        fill="#359138"
                    />
                </svg>
                <h3 style="color: #359138; font-weight: bold; margin: 25px 0px">
                    Registro completado con éxito
                </h3>
            </div>
            <p class="text-center">
                Compartir la vectorización de la propiedad con el agricultor
                para finalizarla
            </p>
            <div class="flex align-items-end justify-content-between">
                <div style="margin-right: 10px" class="w-full">
                    <label style="color: #183b57; font-weight: 600"
                        >Compartir por correo electrónico</label
                    >
                    <el-input
                        placeholder="email@dominio.com"
                        v-model="email"
                        class="w-full"
                        clearable
                    >
                    </el-input>
                </div>
                <el-button
                    type="primary"
                    :loading="loading"
                    @click="enviarEmail()"
                    >Enviar</el-button
                >
            </div>
        </div>
        <template #footer>
            <el-divider></el-divider>

            <div class="dialog-footer">
                <el-button @click="outerVisible = false">Finalizar</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import territorioService from '@/services/TerritorioService';

export default {
    props: {
        isActive: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            email: '',
            loading: false
        };
    },
    methods: {
        async enviarEmail(id) {
            this.loading = true;
            try {
                await territorioService.emaiTerritorio(id, this.email);
            } catch (error) {
                console.log('🚀 ~ getCultura ~ error:', error);
            }
            this.loading = false;
        }
    }
};
</script>
